import { Pipe, PipeTransform } from '@angular/core';
import { PermissionedProductTierName } from '@rivethealth/data/rivet-product';
import { ProductsState } from '../account/products-state.service';

@Pipe({ name: 'hasAnyTier' })
export class HasAnyTierPipe implements PipeTransform {
  constructor(private readonly productsState: ProductsState) {}

  /**
   * Returns true if any of the given tiers on are selected for the current account.
   * @param tiers
   * @returns boolean
   */
  transform(tiers: PermissionedProductTierName[]) {
    return tiers.some(t => this.productsState.hasTier(t));
  }
}

@Pipe({ name: 'hasOnlyTier' })
export class HasOnlyTierPipe implements PipeTransform {
  constructor(private readonly productsState: ProductsState) {}

  /**
   * Returns true if only the given tier is set for the current account.
   * @param tier
   * @returns boolean
   */
  transform(tier: PermissionedProductTierName) {
    return this.productsState.hasOnlyTier(tier);
  }
}
